import { createTheme } from '@mui/material/styles';

// Create a custom theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#E7BAD1', // Customize your primary color
    },
    secondary: {
      main: '#7FBEEB', // Customize your secondary color
    },
    success: {
      main: '#DBD8F0', // Customize your secondary color
    },
    background: {
      default: '#DBD8F0', // Background color
    },
  },

  breakpoints: {
    values: {
      xs: 0,    // Extra small devices
      sm: 760,  // Mobile screens up to 760px
      md: 960,  // Medium devices start at 960px
      lg: 1280,
      xl: 1920,
    },
  },

 

  typography: {
    fontFamily: 'Arial, sans-serif', // Custom font family
    h1: {
      fontSize: '2.5rem',
      fontWeight: 550,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '0.8rem',
      fontWeight: 550,
      color: '#7FBEEB',   
    },
    h4: {
      fontSize: '1.6rem',
      fontWeight: 750,
      color: '#E7BAD1',     
    },
    h5: {  
      fontStyle: 'oblique',  
      fontSize:  "38px", 
      color: '#7FBEEB',
      fontWeight: 800,
    },
    h6: {
      fontSize: '1.0rem',
      fontWeight: 550,
      color: '#E7BAD1',     
    },
    subtitle1: {
      fontStyle: 'oblique'
    },
    subtitle2: {
      fontSize: '1rem',
      color: '#7FBEEB',
      fontWeight: 550,
    },
    body1: {
      fontSize: '1rem'
    },
    body2: {
      color: '#FFF',
      fontStyle: 'oblique',
    },
    
  },
  components: {
    
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          color: "#7FBEEB", // This will specifically target the label for radio buttons
        },
      },
    },
  },
  
});

export default theme;